import { RouteObject } from 'react-router-dom';
import App from '../App';
import portalRoutes from '../../portal/routes';
import dashboardRoutes from '../../dashboard/routes';
import adminRoutes from '../../admin/routes';
import mdmRoutes from '../../mdm/routes';
import logsRoutes from '../../logs/routes';

function appRoutes() {
  return [
    {
      path: '/',
      element: <App />,
      // loader: () => {
      //   const token = User.loadUserToken();
      //   if (!token) {
      //     return redirect('/auth');
      //   }
      //   return null;
      // },
      children: [
        ...portalRoutes, 
        ...dashboardRoutes, 
        ...adminRoutes,
        ...mdmRoutes,
        ...logsRoutes,
      ],
    },
  ] as RouteObject[];
}

export default appRoutes;
